<ng-template pTemplate="header">
  <span class="text-xl font-bold">{{ question_title }}</span>
</ng-template>

<div class="field">
  <form
    [formGroup]="frm"
    (ngSubmit)="save()">
    <label>Nome causale</label>
    <input
      type="text"
      pInputText
      class="w-full mt-1"
      formControlName="name" />
    <div class="flex align-items-center gap-1 mt-3">
      <p-checkbox
        formControlName="maintenance"
        [binary]="true"></p-checkbox>
      <label>Manutenzione</label>
    </div>
  </form>
</div>

<div class="modal-footer">
  <div class="flex justify-content-between">
    <p-button
      icon="pi pi-times"
      type="submit"
      (click)="close()"
      styleClass="butt red"
      [rounded]="true"></p-button>
    <p-button
      icon="pi pi-check"
      type="submit"
      (click)="save()"
      styleClass="butt"
      [rounded]="true"
      [disabled]="this.frm.invalid"></p-button>
  </div>
</div>
